module.exports = __webpack_public_path__ + "static/img/baoming.09df560.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baoming.png
// module id = AJtS
// module chunks = 1